import { Case } from "@types-runway/case";
import { Calendar } from "@types-runway/questionnaire";

export const resolveTripForAddons = (
  stagedCase: Partial<Case> | undefined,
  currentCase: Case
): Calendar => {
  if (stagedCase?.trip) {
    return stagedCase.trip;
  }
  return currentCase.trip;
};
